(function () {
  // Dawn's product-info.js swaps the variant-selects markup in place via a
  // DOM-morph (HTMLUpdateUtility.viewTransition) after every variant change.
  // Morphing sets the `checked` *attribute* on existing radio elements, but
  // once a radio has been interacted with, its live `checked` *property* no
  // longer follows the attribute — so our CSS `:checked` styling (the
  // selected card background and the tick mark) silently goes stale after
  // the first click. Re-sync the property from the attribute whenever the
  // picker's markup changes.
  function syncCheckedState(root) {
    root.querySelectorAll('.cdp-bundle__input').forEach(function (input) {
      var shouldBeChecked = input.hasAttribute('checked');
      if (input.checked !== shouldBeChecked) input.checked = shouldBeChecked;
    });
  }

  function init() {
    document.querySelectorAll('.cdp-bundle').forEach(function (bundle) {
      syncCheckedState(bundle);
      new MutationObserver(function () {
        syncCheckedState(bundle);
      }).observe(bundle, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
